import { IParkingPoolProfile } from '../graphql/parkingPool/getTenantParkingPoolUsers'

export const findDefaultProfile = (
  profiles: IParkingPoolProfile[],
): IParkingPoolProfile | undefined => profiles.find(p => p.isDefault === true)
